import {validatePresence, validateIncludes} from "./Validators";
import {getUSStates, getCanadaProvinces, isUS, isCanada} from "./CountriesAndStates";
import {Map} from "immutable";

export function validateForm(values, props) {
  let errors = Map();
  errors = validatePresence(errors, values, "type");
  errors = validatePresence(errors, values, "name");
  errors = validatePresence(errors, values, "addressCountryCode");
  errors = validatePresence(errors, values, "addressAddressLine1");
  errors = validatePresence(errors, values, "addressCity");
  if (isUS(values.get("addressCountryCode"))) {
    let usStates = getUSStates().map(x => x.get("code"));
    errors = validateIncludes(errors, values, "addressStateProvince", usStates);
  } else {
    errors = validatePresence(errors, values, "addressStateProvince");
  }
  if (isCanada(values.get("addressCountryCode"))) {
    let provinces = getCanadaProvinces().map(x => x.get("code"));
    errors = validateIncludes(errors, values, "addressStateProvince", provinces);
  } else {
    errors = validatePresence(errors, values, "addressStateProvince");
  }
  errors = validatePresence(errors, values, "addressPostcode");
  return errors.toJS();
}
